export class ChartHintState<T> {
    public hint?: T;
}
